<div class="card">
    <div class="card-body">
        <div class="row">
            <div
                class="mb-3"
                [ngClass]="displayLinksSection ? 'col-12 col-sm-6 col-md-3' : 'col-12 col-sm-6 col-md-4'"
                *ngIf="displayDataMaintenanceSection"
            >
                <h4 translate="NOTIFICATION_DETAILS_DETAIL_LINKS_DATA_MAINTENANCE_TITLE"></h4>
                <div>
                    <button class="btn btn-link" (click)="openNotificationMaintenanceLocation()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MAINTENANCE_LOCATION"></span>
                    </button>
                </div>

                <div>
                    <button class="btn btn-link" (click)="openNotificationMaintenanceSysConfig()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MAINTENANCE_SYSTEM_CONFIG"></span>
                    </button>
                </div>
            </div>
            <div class="mb-3" [ngClass]="displayLinksSection ? 'col-12 col-sm-6 col-md-3' : 'col-12 col-sm-6 col-md-4'">
                <h4 translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENTS_TITLE"></h4>
                <div *ngIf="displayEquipmentHistory">
                    <button class="btn btn-link" (click)="openEquipmentHistory()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_HISTORY"></span>
                    </button>
                </div>
                <div>
                    <button class="btn btn-link" (click)="openEquipmentConfig()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_SUB_EQUIPMENT"></span>
                    </button>
                </div>
                <div *ngIf="displayOtherTasks">
                    <button class="btn btn-link" (click)="openEquipmentOtherTasks()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_EQUIPMENT_OTHER_TASKS"></span>
                    </button>
                </div>
            </div>
            <div
                class="mb-3"
                [ngClass]="
                    displayLinksInMultiColumns
                        ? 'col-12 col-sm-6 col-md-2'
                        : displayLinksSection
                          ? 'col-12 col-sm-6 col-md-3'
                          : 'col-12 col-sm-6 col-md-4'
                "
                *ngIf="displayMaterialSection && !notification.isApplicationSpecialist"
            >
                <h4 translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MATERIAL_TITLE"></h4>
                <div>
                    <button
                        class="btn btn-link"
                        (click)="openNotificationMaterialRequest()"
                        [disabled]="isMaterialRequested()"
                    >
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MATERIAL_REQUEST"></span>
                    </button>
                </div>
                <div *ngIf="displayMaterialQuote">
                    <button class="btn btn-link" (click)="openNotificationSalesQuote()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MATERIAL_QUOTE"></span>
                    </button>
                </div>
                <div *ngIf="displayMaterialPricing">
                    <button class="btn btn-link" (click)="openNotificationMaterialPricing()">
                        <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_MATERIAL_PRICING"></span>
                    </button>
                </div>
            </div>
            <div
                [ngClass]="displayLinksInMultiColumns ? 'col-12 col-sm-6 col-md-4' : 'col-12 col-sm-6 col-md-3'"
                *ngIf="displayLinksSection"
            >
                <h4 translate="NOTIFICATION_DETAILS_DETAIL_LINKS_LINKS_TITLE"></h4>
                <div class="links">
                    <div class="link-container">
                        <div paceCoreLink *ngIf="teamPlayFleetLinkForNotification.length > 0">
                            <a
                                href="{{ teamPlayFleetLinkForNotification }}"
                                class="pace-link btn btn-link"
                                target="_blank"
                            >
                                <span>teamplay Fleet</span>
                            </a>
                        </div>
                        <div paceCoreLink *ngIf="serviceSoftwareOnlineLinkForNotification.length > 0">
                            <a
                                href="{{ serviceSoftwareOnlineLinkForNotification }}"
                                class="pace-link btn btn-link"
                                target="_blank"
                            >
                                <span>SeSO</span>
                            </a>
                        </div>
                        <div *ngIf="displayDocBox">
                            <button class="btn btn-link" (click)="callDocBoxPage()">
                                <span translate="NOTIFICATION_DETAILS_DETAIL_LINKS_DOC_BOX"></span>
                            </button>
                        </div>
                        <div *ngIf="byBoxKonnectLink.length > 0" paceCoreLink>
                            <a href="{{ byBoxKonnectLink }}" class="pace-link btn btn-link" target="_blank">
                                <span>ByBox Konnect</span>
                            </a>
                        </div>
                        <div paceCoreLink *ngIf="cbDocOnlineLink.length > 0">
                            <a href="{{ cbDocOnlineLink }}" class="pace-link btn btn-link" target="_blank">
                                <span>CB-Doc</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
